import { z } from 'zod';

const ActiveFiltersSchema = z.object({
    expert_type: z.enum(['freelancer', 'agency', 'app_service_provider']).optional(),
    services_offered: z.array(z.string()).optional(),
    starting_price: z.object({
        from: z.number().optional(),
        to: z.number().optional(),
    }).optional(),
    countries: z.array(z.string()).optional(),
    languages: z.array(z.string()).optional(),
    apps_and_themes: z.array(z.string()).optional(),
    search: z.string().optional(),
});

export const ExpertListingMetaSchema = z.object({
    count: z.number(),
    active_filters: ActiveFiltersSchema.optional(),
    review_stats: z.object({
        average_rating: z.number(),
        reviews_count: z.number(),
    }).optional(),
});

export type ExpertListingMeta = z.infer<typeof ExpertListingMetaSchema>;
export type ActiveFilters = z.infer<typeof ActiveFiltersSchema>;
